import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IConnectionsState {
    isConnectionsFinished: boolean
}

const initialState: IConnectionsState = {
    isConnectionsFinished: false,
}

export const connectionsSlice = createSlice({
    name: 'connectionsSlice',
    initialState,
    reducers: {
        setConnectionsFinished: (state, action: PayloadAction<{isConnectionsFinished: boolean}>) => {
            state.isConnectionsFinished = action.payload.isConnectionsFinished
        },
    },
})

export const {
  setConnectionsFinished,
} = connectionsSlice.actions

export default connectionsSlice.reducer
